<div class="grid grid-cols-12 gap-4 mb-4">
  <div class="col-span-12">
    <ng-container *accessView="['CertPeriod.Create']">
      <div class="flex justify-end"> <button pButton type="button" icon="pi pi-plus"
        [disabled]="!isEligibleForNextCert" class="p-button flex" label="Create Cert Period"
      (click)="onAddNextCertPeriod()" data-test-id="hipps-show-cert-button"></button></div>
    </ng-container>

    @if (certPeriodChangedManually && !isExternal) {
      <p-message class="mt-4" severity="warn" icon="pi pi-exclamation-triangle">
        <div>Cert period date ranges have been manually adjusted for this authorization.</div>
      </p-message>
    }
  </div>
</div>

<p-table
  [columns]="cols"
  [value]="certPeriodSorted"
  [paginator]="true"
  [alwaysShowPaginator]="false"
  [rows]="5"
  [scrollable]="false"
  >
  <p-dialog header="Create Cert Period" [(visible)]="showNextCertModal" [modal]="true" appendTo="body" [closable]="true"
    [resizable]="false" [style]="{ width: '400px', maxWidth: '400px' }" [minY]="180" [maximizable]="false">

    <p class="mb-4">
      <b> Are you sure that you want to create Cert Period {{ this.certPeriodSorted[0]?.certPeriod+1 }} ?</b>
    </p>
    <div class="mb-4">
      <p class="mb-1">
        Effective From:
      </p>
      <p>
        {{ nextCertView?.effectiveFromDate| date:'MM/dd/yyyy' }}
      </p>
    </div>
    <div class="mb-4">
      <p class="mb-1">
      Effective To: </p>
      <p>{{ nextCertView?.effectiveToDate| date:'MM/dd/yyyy' }}</p>
    </div>
    <div class="mb-4">
      <p class="mb-1">
      Review Period A: </p>
      <p> {{ nextCertView?.reviewPeriods[0]?.startDate | date:'MM/dd/yyyy' }} -
        {{ nextCertView?.reviewPeriods[0]?.endDate | date:'MM/dd/yyyy' }}
      </p>
    </div>
    <div class="mb-4">
      <p class="mb-1">
      Review Period B: </p>
      <p>{{ nextCertView?.reviewPeriods[1]?.startDate | date:'MM/dd/yyyy' }} -
      {{ nextCertView?.reviewPeriods[1]?.endDate | date:'MM/dd/yyyy' }}</p>
    </div>

    <ng-template pTemplate="footer">
      <button type="button" pButton label="Cancel" class="p-button-secondary" (click)="showNextCertModal = false">
      </button>

      <button type="button" pButton label="Create" class="mr-2" [disabled]="!isEligibleForNextCert"
        (click)="createNextCertPeriod()">
      </button>
    </ng-template>
  </p-dialog>
  <ng-template pTemplate="colgroup" let-columns>
    <colgroup>
    <ng-container *accessView="['CertPeriod.Update']">
      <col *accessController="['OperationsAdmin']" style="width: 3rem">
    </ng-container>
    @for (col of columns; track col) {
      <col [style]="col.style" >
    }
  </colgroup>
</ng-template>
<ng-template pTemplate="header" let-columns>
  <tr>
    <ng-container *accessView="['CertPeriod.Update']">
      <th *accessController="['OperationsAdmin']" data-test-id="edit-cert-column-header-label"></th>
    </ng-container>
    @for (col of columns; track col) {
      <th
        [pSortableColumn]="col.field"
        [attr.data-test-id]="col.header + '-label'"
        >
        {{ col.header }}
        @if (!isHH30DayReviewPeriods) {
          <p-sortIcon
            [field]="col.field"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
            >
          </p-sortIcon>
        } @else {
          @if (col.isSortable) {
            <p-sortIcon
              [field]="col.field"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
              >
            </p-sortIcon>
          }
        }
      </th>
    }
  </tr>
</ng-template>
<ng-template pTemplate="body" let-authCert let-columns="columns">
  <tr>
    <ng-container *accessView="['CertPeriod.Update']">
      <td *accessController="['OperationsAdmin']" class="py-0">
        <button
          title="Edit"
          type="button"
          pButton
          class="p-button-rounded p-button-text p-button-lg"
          icon="pi pi-pencil"
          (click)="onEditCertPeriod(authCert)"
          data-test-id="edit-cert-column-button"
          >
        </button>
      </td>
    </ng-container>
    @for (col of columns; track col) {
      @if (col.header == 'Cert Period') {
        <td data-test-id="cert-period-value">
          {{ authCert[col.field] }}
        </td>
      }
      @if (col.header == 'Effective From') {
        <td data-test-id="effective-from-value">
          {{ authCert[col.field] | date: 'MM/dd/yyyy' }}
        </td>
      }
      @if (col.header == 'Effective To') {
        <td data-test-id="effective-to-value">
          {{ authCert[col.field] | date: 'MM/dd/yyyy' }}
        </td>
      }
      @if (isHH30DayReviewPeriods && col.header == 'Review Period A') {
        <td data-test-id="effective-to-value">
          @for (reviewPeriod of authCert.reviewPeriods; track reviewPeriod) {
            @if (reviewPeriod.reviewPeriodType == reviewPeriodType.ReviewPeriodA) {
              <span>
                {{ reviewPeriod.startDate | date: 'MM/dd/yyyy' }} - {{ reviewPeriod.endDate | date: 'MM/dd/yyyy' }}
              </span>
            }
          }
        </td>
      }
      @if (isHH30DayReviewPeriods && col.header == 'Review Period B') {
        <td data-test-id="effective-to-value">
          @for (reviewPeriod of authCert.reviewPeriods; track reviewPeriod) {
            @if (reviewPeriod.reviewPeriodType == reviewPeriodType.ReviewPeriodB) {
              <span>
                {{ reviewPeriod.startDate | date: 'MM/dd/yyyy' }} - {{ reviewPeriod.endDate | date: 'MM/dd/yyyy' }}
              </span>
            }
          }
        </td>
      }
      @if (col.header == 'HIPPS Code') {
        <td class="py-0">
          <div class="flex justify-between">
            <div>
              @if (authCert[col.field]) {
                <span class="p-tag p-tag-rounded code-tag-lg mr-1" data-test-id="hipss-value">
                  {{ authCert[col.field] }}
                <ng-container *accessController="[
                  'AppealGrievance',
                  'OperationsAdmin',
                  'Operations',
                  'Internal',
                  'LetterMapsManager'
                ]">
                    <ng-container *accessView="['CertPeriod.HippsCode.Update']">
                      <button
                        pButton
                        type="button"
                        icon="pi pi-times"
                        class="p-button-rounded p-button-ssm p-button-text p-button-plain"
                        (click)="removeHippsCode(authCert, col.field)"
                        data-test-id="hipps-button"
                      ></button>
                    </ng-container>
                  </ng-container>
                </span>
              }
              @if (authCert[col.secondField]) {
                <span class="p-tag p-tag-rounded code-tag-lg" data-test-id="second-hipps-value">
                  {{ authCert[col.secondField] }}
                <ng-container *accessController="[
                  'AppealGrievance',
                  'OperationsAdmin',
                  'Operations',
                  'Internal',
                  'LetterMapsManager'
                ]">
                    <ng-container *accessView="['CertPeriod.HippsCode.Update']">
                      <button
                        pButton
                        type="button"
                        icon="pi pi-times"
                        class="p-button-rounded p-button-ssm p-button-text p-button-plain"
                        (click)="removeHippsCode(authCert, col.secondField)"
                        data-test-id="second-hipps-button"
                      ></button>
                    </ng-container>
                  </ng-container>
                </span>
              }
            </div>
            <div>
              <ng-container *accessController="[
                'AppealGrievance',
                'OperationsAdmin',
                'Operations',
                'Internal',
                'LetterMapsManager'
              ]">
                <ng-container *accessView="['CertPeriod.HippsCode.Update']">
                  @if (!authCert[col.field] || !authCert[col.secondField]) {
                    <button
                      pButton
                      type="button"
                      icon="pi pi-plus"
                      class="p-button-rounded p-button-sm"
                      (click)="showCertModal = true; currentCertPeriod = authCert"
                      data-test-id="hipps-show-cert-button"
                    ></button>
                  }
                </ng-container>
              </ng-container>
            </div>
          </div>
        </td>
      }
    }
  </tr>
</ng-template>
</p-table>

<app-hipps-code-dialog [show]="showCertModal" (selectHippsCode)="handleHippsCode($event)"></app-hipps-code-dialog>
